import React from 'react';

import Loader from 'components/Loader';
import Section from 'components/Section';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelReportRequest, ReportSummary } from 'models/reportSummary';

import ReportTimeline from '../../../ReportTimeline';
import ReportItem from '../ReportItem';
import { SummaryCard, SummarySubtitle, SummaryTitle, Divider, ReportSummaryContainer } from './styles';

interface Props {
  filters?: TravelReportRequest;
  isLoading?: boolean;
  travelReport?: ReportSummary;
  dateSelected?: string;
}

const Summary = ({ travelReport, dateSelected, isLoading }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        travelReport && (
          <ReportSummaryContainer>
            <Section title={t('travelReport.reportSummary.title')} joinContent>
              <SummaryCard>
                <div>
                  <SummaryTitle>
                    {dateSelected
                      ? t('travelReport.reportSummary.report', { title: dateSelected })
                      : t('travelReport.reportSummary.lastDaysUpdated')}
                  </SummaryTitle>
                  <SummarySubtitle>{t('travelReport.reportSummary.reportSubtitle')}</SummarySubtitle>
                </div>
                <ReportItem
                  currency={travelReport.currency}
                  totalTripsValues={travelReport.totalTripsValues}
                  totalTrips={travelReport.totalTrips}
                  totalAir={travelReport.totalAir}
                  totalAirValues={travelReport.totalAirValues}
                  totalHotel={travelReport.totalHotel}
                  totalHotelValues={travelReport.totalHotelValues}
                />
              </SummaryCard>
            </Section>

            {travelReport?.logs?.length > 0 && (
              <>
                <Divider />

                <ReportTimeline reports={travelReport.logs} />
              </>
            )}
          </ReportSummaryContainer>
        )
      )}
    </>
  );
};

export default Summary;
